import { ReportReason, ReportStatus, ReportTargetType } from '../../api/generated/boticaAPI.schemas';

/**
 * The API serialises enums by NAME (BoticaJsonOptions), so orval renders them as
 * const objects keyed by member name. Mapped to labels once here rather than
 * repeating the indirection in both report pages (§9.100).
 */

export const STATUS_LABEL: Record<string, string> = {
  [ReportStatus.Pending]: 'Pending',
  [ReportStatus.Actioned]: 'Actioned',
  [ReportStatus.Dismissed]: 'Dismissed',
};

export const STATUS_BADGE: Record<string, 'neutral' | 'pending' | 'approved' | 'rejected'> = {
  [ReportStatus.Pending]: 'pending',
  [ReportStatus.Actioned]: 'approved',
  [ReportStatus.Dismissed]: 'neutral',
};

export const REASON_LABEL: Record<string, string> = {
  [ReportReason.Spam]: 'Spam',
  [ReportReason.Harassment]: 'Harassment',
  [ReportReason.Misinformation]: 'Misinformation',
  [ReportReason.Impersonation]: 'Impersonation',
  [ReportReason.Other]: 'Other',
};

export const TARGET_LABEL: Record<string, string> = {
  [ReportTargetType.Post]: 'Post',
  [ReportTargetType.Comment]: 'Comment',
  [ReportTargetType.Message]: 'Message',
  [ReportTargetType.User]: 'User',
  [ReportTargetType.AvailabilityRequest]: 'Availability request',
};

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
